<template lang="pug">
    Page.advantages-object
        .advantages-object__top(
            slot="header"
        )
            h1.advantages-object__title
                | Преимущества объекта

            .advantages-object__subheader
                SvInput.advantages-object__search(
                    v-model="search"
                    placeholder="Введите название преимущества"
                    color="gray"
                    size="large"
                )

                SvButton.advantages-object__add(
                    view="big"
                    text="Добавить"
                    :prependIcon=`{
                    icon: 'plus',
                    width: 17,
                    height: 17,
                    fillDefault: '#fff',
                    fillHover: '#fff'
                }`
                    @click="transfer('new')"
                )

        SvTable.advantages-object__table(
            :headers="fieldList"
            :body="getList"
            :emptyText="emptyText"
            @transfer="(el) => transfer(el.id)"
        )
</template>

<script>
import {mapGetters} from 'vuex';
import {fields} from '@/config/advantagesObject.js';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTable from '@/components/uikit/SvTable.vue';

export default {
    name: 'AdvantagesObjects',

    beforeMount() {
        this.$store.dispatch('advantageObject/getList');
    },

    computed: {
        ...mapGetters({
            getList: 'advantageObject/getList',
        }),

        fieldList() {
            return fields;
        },

        emptyText() {
            return this.search ? 'Ничего не найдено' : 'Здесь пока ничего нет';
        },

        search: {
            get() {
                return this.$store.state.advantageObject.search;
            },

            set(search) {
                this.$store.commit('advantageObject/setSearch', search);
            },
        },
    },

    methods: {
        transfer(id) {
            this.$router.push({
                name: 'advantage-object-edit',
                params: {id},
            });
        },
    },

    components: {
        Page,
        SvInput,
        SvButton,
        SvTable,
    },
};
</script>

<style lang="scss" scoped>
.advantages-object__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.advantages-object__subheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.advantages-object__search {
    width: 47%;
    min-width: 280px;
}

.advantages-object__table {
    margin-top: 30px;
}
</style>
